'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ERROR_CODES = /* @__PURE__ */ ((ERROR_CODES2) => {
  ERROR_CODES2[ERROR_CODES2["OUT_OF_TURN"] = 400018] = "OUT_OF_TURN";
  ERROR_CODES2[ERROR_CODES2["OUT_OF_PRIZE"] = 400020] = "OUT_OF_PRIZE";
  return ERROR_CODES2;
})(ERROR_CODES || {});
const DEFAULT_LUCKY_DRAW_V2 = {
  id: null,
  backgroundColors: [
    "#ff7491",
    "#2ff3cf",
    "#2bb5fe",
    "#f5ea3a",
    "#bfeefc",
    "#ec4c4c",
    "#019ade",
    "#00cc6b",
    "#cc33ff",
    "#90e228",
    "#7e4bff",
    "#ffc502"
  ],
  prizeAngle: 90,
  spinDuration: 1,
  textColors: ["white"],
  canvasConfig: {
    innerRadius: 0,
    fontSize: 17,
    radiusLineColor: "#eeeeee",
    radiusLineWidth: 0,
    perpendicularPrize: true,
    textDistance: 60,
    border: {
      innerBorderColor: "#ffffff",
      innerBorderWidth: 0,
      outerBorderColor: "#ffffff",
      outerBorderWidth: -10,
      image: {
        src: "https://lh3.googleusercontent.com/SVu3oUkfvSqHso_2nPT7ZV-tbkcXohRGK73XK-0RAieqjpVzvahMB_sNerbsD9z-RU9YgVEQz8OvJDPC2FX2xz-u5tK8Vpcw"
      }
    }
  },
  spinTrigger: {
    text: "Spin",
    buttonStyle: {
      backgroundColor: "#ff4646",
      borderColor: "#328ed9",
      borderWidth: 6,
      color: "#ffffff",
      fontSize: "1.5em",
      fontWeight: "bold",
      hover: {
        zoom: 105
      }
    },
    image: {
      src: "https://lh3.googleusercontent.com/r5nZppsbH9EsI9GdyNqXFH19lto88WhhL2XL1Juexc9sElHTLXUWx-8HkHwMwsoe6rpVe3R3m2gR6fC10yMJ7s8U4mBgaW4"
    },
    imageStyle: {
      hover: {
        zoom: 110
      }
    }
  },
  roulette: {
    rotate: 90,
    color: "#328ed9",
    size: 40
  }
};
const DEFAULT_POPUP_PRIZE_V2 = (popupName) => ({
  ".dp27jtsb": {
    id: ".dp27jtsb",
    elementId: "7PhZ7Orijk",
    parentId: "ROOT",
    tag: "popupv1",
    resolvedName: "PopupEditorV1",
    style: {
      width: 400,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 24,
        top: 0
      },
      borderRadius: 24,
      borderColor: "#ff5722ff"
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      popupv1: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        maskClosable: true,
        maskStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.1)"
        },
        position: "default",
        name: popupName,
        showCloseIcon: true
      }
    },
    children: [
      ".wmmjc6p0",
      ".t3o9bcjz",
      ".xl9nmif2",
      ".ishc5gft",
      ".likgxefm",
      ".ar9360ca"
    ]
  },
  ".wmmjc6p0": {
    id: ".wmmjc6p0",
    parentId: ".dp27jtsb",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".t3o9bcjz": {
    id: ".t3o9bcjz",
    parentId: ".dp27jtsb",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 60,
      widthUnit: "%",
      height: 100,
      heightUnit: "%"
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/TCygQ0UckARy2xGqh3lBAcEJLpEbCRdjqvk4OnuOm5FVWchbXgFNFI_WgOoparnjX0xkQ_fK5W3qNHQVEXY3Xliqm62CADPUfA",
        googleImageParams: {
          percent: 100,
          width: 1088
        }
      }
    },
    children: []
  },
  ".xl9nmif2": {
    id: ".xl9nmif2",
    parentId: ".dp27jtsb",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 75,
      widthUnit: "%",
      height: 100,
      heightUnit: "%"
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/dMzPbBXMFw4WUKWqtdw0wxFvRxXuoVQwsJH6iQg4nx-CDzLynOTPao3qLnT7926_UDIOrzdhdKx41DuTMf1luoMIAuyQ3UuyTQ",
        googleImageParams: {
          percent: 100,
          width: 1053
        }
      }
    },
    children: []
  },
  ".ishc5gft": {
    id: ".ishc5gft",
    parentId: ".dp27jtsb",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">{{name}}</span></strong></h2>'
      }
    },
    children: []
  },
  ".likgxefm": {
    id: ".likgxefm",
    parentId: ".dp27jtsb",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".ar9360ca": {
    id: ".ar9360ca",
    parentId: ".dp27jtsb",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">Ch\xFAc m\u1EEBng b\u1EA1n \u0111\xE3 nh\u1EADn \u0111\u01B0\u1EE3c ph\u1EA7n qu\xE0 {{name}}!</span></strong></h6>'
      }
    },
    children: []
  },
  "83EW4j2go1": {
    id: "83EW4j2go1",
    parentId: "ROOT",
    tag: "section",
    resolvedName: "RowEditor",
    style: {
      padding: {
        top: 8,
        bottom: 8,
        left: 16,
        right: 16
      },
      maxWidth: 1232,
      margin: {
        bottom: 1e3
      }
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      section: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        gutter: [0, 0],
        widthType: "fixed"
      }
    },
    children: ["tvXFs-v-ux"]
  },
  "tvXFs-v-ux": {
    id: "tvXFs-v-ux",
    parentId: "83EW4j2go1",
    tag: "col",
    resolvedName: "ColEditor",
    style: {
      padding: {
        left: 15,
        top: 5,
        bottom: 5,
        right: 15
      }
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      col: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        md: {
          flex: "100%"
        },
        xs: {
          flex: "100%"
        }
      }
    },
    children: []
  }
});
const DEFAULT_POPUP_OUT_OF_MOVE_V2 = (popupName) => ({
  ".xgukw6ne": {
    id: ".xgukw6ne",
    elementId: "7PhZ7Orijk",
    parentId: "ROOT",
    tag: "popupv1",
    resolvedName: "PopupEditorV1",
    style: {
      width: 400,
      height: 200,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 24,
        top: 0
      },
      borderRadius: 24,
      borderColor: "#ff5722ff"
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      popupv1: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        maskClosable: true,
        maskStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.1)"
        },
        position: "default",
        name: popupName,
        showCloseIcon: true
      }
    },
    children: [
      ".k85i8qdw",
      ".g7ef9s9p",
      ".lvhq4cof",
      ".1gmmca8b",
      ".gqixp832",
      ".vrduzqmv"
    ]
  },
  ".k85i8qdw": {
    id: ".k85i8qdw",
    parentId: ".xgukw6ne",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".g7ef9s9p": {
    id: ".g7ef9s9p",
    parentId: ".xgukw6ne",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 60,
      widthUnit: "%",
      height: 100,
      heightUnit: "%",
      margin: {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
      }
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",
        googleImageParams: {
          percent: 100,
          width: 1088
        }
      }
    },
    children: []
  },
  ".lvhq4cof": {
    id: ".lvhq4cof",
    parentId: ".xgukw6ne",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".1gmmca8b": {
    id: ".1gmmca8b",
    parentId: ".xgukw6ne",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">B\u1EA1n \u0111\xE3 h\u1EBFt l\u01B0\u1EE3t quay!</span></strong></h2>'
      }
    },
    children: []
  },
  ".gqixp832": {
    id: ".gqixp832",
    parentId: ".xgukw6ne",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".vrduzqmv": {
    id: ".vrduzqmv",
    parentId: ".xgukw6ne",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">Vui l\xF2ng th\u1EED l\u1EA1i sau nh\xE9</span></strong></h6>'
      }
    },
    children: []
  }
});
const DEFAULT_POPUP_OUT_OF_PRIZE_V2 = (popupName) => ({
  BraTGniUhP: {
    id: "BraTGniUhP",
    parentId: "7PhZ7Orijk",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  hZJ3PSQWs3: {
    id: "hZJ3PSQWs3",
    parentId: "7PhZ7Orijk",
    tag: "image",
    resolvedName: "ImageEditor",
    style: {
      width: 60,
      widthUnit: "%",
      height: 100,
      heightUnit: "%",
      margin: {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
      }
    },
    isActive: false,
    isCanvas: false,
    customAttributes: {
      image: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        src: "https://lh3.googleusercontent.com/B8UCNG5G1RPLbQ4ytQDyUIKOAIEgZKtDSKhlQloAcQB7Xak1Xfv6wnPWfXmdVuNb6w9Zn8krUlixTa_F3z7HOUnyiT6e3fZL",
        googleImageParams: {
          percent: 100,
          width: 1088
        }
      }
    },
    children: []
  },
  ".wuwrv13b": {
    id: ".wuwrv13b",
    parentId: "7PhZ7Orijk",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  UeMBzuDA2c: {
    id: "UeMBzuDA2c",
    parentId: "7PhZ7Orijk",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h2 style="text-align: center; font-family: Quicksand"><strong><span style="font-size: 24px; color: rgb(27, 29, 41); background-color: rgb(255, 255, 255); font-weight: 700; text-transform: none">R\u1EA5t ti\u1EBFc, qu\xE0 \u0111\xE3 h\u1EBFt!</span></strong></h2>'
      }
    },
    children: []
  },
  ".cyapx8b1": {
    id: ".cyapx8b1",
    parentId: "7PhZ7Orijk",
    tag: "spacer",
    resolvedName: "SpacerEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      spacer: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        height: 16
      }
    },
    children: []
  },
  ".vt2iwmb0": {
    id: ".vt2iwmb0",
    parentId: "7PhZ7Orijk",
    tag: "heading",
    resolvedName: "HeadingEditor",
    style: {},
    isActive: false,
    isCanvas: false,
    customAttributes: {
      heading: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        text: '<h6 style="text-align: center; font-size: 16px; font-family: Quicksand"><strong><span style="color: rgb(67, 70, 87); font-weight: 400">Vui l\xF2ng th\u1EED l\u1EA1i sau nh\xE9</span></strong></h6>'
      }
    },
    children: []
  },
  "7PhZ7Orijk": {
    id: "7PhZ7Orijk",
    elementId: "7PhZ7Orijk",
    parentId: "ROOT",
    tag: "popupv1",
    resolvedName: "PopupEditorV1",
    style: {
      width: 400,
      height: 200,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 24,
        top: 0
      },
      borderRadius: 24,
      borderColor: "#ff5722ff"
    },
    isActive: false,
    isCanvas: true,
    customAttributes: {
      popupv1: {
        responsive: {
          hiddenXs: false,
          hiddenMd: false
        },
        maskClosable: true,
        maskStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.1)"
        },
        position: "default",
        name: popupName,
        showCloseIcon: true
      }
    },
    children: [
      "BraTGniUhP",
      "hZJ3PSQWs3",
      ".wuwrv13b",
      "UeMBzuDA2c",
      ".cyapx8b1",
      ".vt2iwmb0"
    ]
  }
});

exports.DEFAULT_LUCKY_DRAW_V2 = DEFAULT_LUCKY_DRAW_V2;
exports.DEFAULT_POPUP_OUT_OF_MOVE_V2 = DEFAULT_POPUP_OUT_OF_MOVE_V2;
exports.DEFAULT_POPUP_OUT_OF_PRIZE_V2 = DEFAULT_POPUP_OUT_OF_PRIZE_V2;
exports.DEFAULT_POPUP_PRIZE_V2 = DEFAULT_POPUP_PRIZE_V2;
exports.ERROR_CODES = ERROR_CODES;
